import '../scss/contact-page-style.scss';
import ContactPage from './pages/contact/index';

document.addEventListener('DOMContentLoaded', () => {
  ContactPage.init();
});